import { dt, sDuration, mDistance, brNum } from 'oderon-commons/src/formatters'
import { preProcessSpec } from 'oderon-commons/src/tables'
import { anyEmpty, any0 } from '../../utils'

export const defCodes = [
  'id',
  'driver',
  'isValid',
  'startTimestamp',
  'endTimestamp',
  'durationS',
  'lapseCount',
  'distanceM',
  'incOdos'
]

const check = 'mdi-checkbox-marked-circle',
  greatcheck = 'mdi-check-decagram',
  cross = 'mdi-close-circle',
  triangle = 'mdi-alert',
  green = 'green--text icon-small',
  red = 'red--text icon-small',
  yellow = 'amber--text icon-small',
  blue = 'blue--text icon-small'

// NB: .value é necessário porque senão o ODataCell
// renderiza uma célula vazia (mesmo com dados do icon)
export const valid = { iconText: check, iconClass: green, value: true }
export const invalid = { iconText: cross, iconClass: red, value: false }
export const warns = { iconText: triangle, iconClass: yellow, value: false }
export const great = { iconText: greatcheck, iconClass: blue, value: true }

export function isGreat(row) {
  let coords = [row.lat0, row.lng0]
  if (anyEmpty(...coords) || any0(...coords)) return false
  if (row.distanceM < 9000) return false
  return true
}

export const fullSpec = preProcessSpec({
  defCodes: [
    'id',
    'vehicleCode',
    'status',
    'startTimestamp',
    'errorMessage',
    'driverName',
    'durationS',
    'distanceM'
  ],
  columns: [
    {
      t: 'ID|',
      d: 'id',
      w: 80,
      code: 'id',
      sortBy: false,
      selectable: true,
      color: '#aaaaaa'
    },

    {
      t: 'Veículo',
      d: 'vehicle.code',
      code: 'vehicleCode',
      sortBy: false,
      selectable: true
    },
    {
      t: 'G.Veículo',
      d: 'vehicle.group',
      code: 'vehicleGroup',
      sortBy: false,
      selectable: true
    },

    {
      t: 'Motorista',
      d: 'driver.name',
      sortBy: false,
      code: 'driverName',
      selectable: true
    },

    {
      t: 'Crachá',
      d: 'serial',
      sortBy: false,
      code: 'serial',
      selectable: true
    },

    {
      t: 'G.Motorista',
      d: 'driver.group',
      code: 'driverGroup',
      sortBy: false,
      selectable: true
    },

    {
      t: '|Status|',
      w: 40,
      sortBy: false,
      code: 'status',
      selectable: true,
      d: (r) => {
        if (!r.isValid) return invalid
        if (r.errorMessage != null) return warns
        if (isGreat(r)) return great
        return valid
      }
    },

    {
      t: 'Erro',
      d: 'errorMessage',
      sortBy: false,
      selectable: true
    },

    {
      t: 'Início|',
      d: 'startTimestamp',
      w: 220,
      sortBy: false,
      code: 'startTimestamp',
      selectable: true,
      f: dt
    },

    {
      t: 'Fim|',
      d: 'endTimestamp',
      w: 220,
      sortBy: false,
      code: 'endTimestamp',
      selectable: true,
      f: dt
    },

    {
      t: 'Criado em|',
      d: 'createdAt',
      w: 220,
      sortBy: false,
      code: 'createdAt',
      selectable: true,
      f: dt
    },

    {
      t: 'Atualizado em|',
      d: 'updatedAt',
      w: 220,
      sortBy: false,
      code: 'updatedAt',
      selectable: true,
      f: dt
    },

    {
      t: 'Fechada em|',
      d: 'closedAt',
      w: 220,
      sortBy: false,
      code: 'closedAt',
      selectable: true,
      f: dt
    },

    {
      t: 'Odo Início|',
      d: 'startOdometer',
      w: 100,
      sortBy: false,
      code: 'startOdometer',
      selectable: true
    },

    {
      t: 'Odo Fim|',
      d: 'endOdometer',
      w: 100,
      sortBy: false,
      code: 'endOdometer',
      selectable: true
    },

    {
      t: 'Duração|',
      d: 'durationS',
      w: 70,
      f: sDuration,
      sortBy: false,
      code: 'durationS',
      selectable: true
    },

    {
      t: 'Lapsos|',
      d: 'lapseCount',
      w: 70,
      f: brNum,
      sortBy: false,
      code: 'lapseCount',
      selectable: true
    },

    {
      t: 'Dist. (m)|',
      d: 'distanceM',
      w: 70,
      f: mDistance,
      sortBy: false,
      code: 'distanceM',
      selectable: true
    },

    {
      t: 'IncOdos|',
      d: 'incOdos',
      w: 70,
      f: brNum,
      sortBy: false,
      code: 'incOdos',
      selectable: true
    }
  ],
  rowClass: (r) => {
    return r.isOngoing ? 'blue lighten-4' : ''
  }
})
